
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, Axios)

Vue.config.productionTip = false

var boars = "\n\n\n    🐗🐗 ≡3　\n　    🐗🐗🐗🐗🐗 ≡≡3 \n　 　  　🐗🐗🐗🐗🐗🐗🐗 ≡≡≡3\n     🐗🐗🐗🐗🐗🐗🐗 ≡≡3 \n    🐗🐗🐗🐗🐗🐗🐗🐗🐗 ≡≡3\n     🐗🐗🐗🐗🐗≡≡3\n    🐗🐗🐗 ≡3\n   🐗🐗 ≡3\n\n\n\n"

console.log("%cWe boar !!", 'color: #51423b;font-size:20px;');
console.log(boars);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // store,
})

// export default new Vuex.Store({
//   modules: {
//     Loading
//   }
// })



// WEBPACK FOOTER //
// ./src/main.js